export default () => {
	const menuBtn = document.querySelector(".menu-toggle");

	if (menuBtn) {
		menuBtn.addEventListener("click", () => {
			document.querySelector(".site-header").classList.toggle("active");
		});
	}
};
